import { EditorFilter } from "../types";

// // // //

/**
 * removeDuplicateSiblings
 * Removes duplicate sibling filters from the nested filters of an EditorFilter recursively based on their ID.
 * @function removeDuplicateSiblings
 * @param {EditorFilter} filter - The EditorFilter to remove duplicate sibling filters from.
 * @returns {EditorFilter} - The modified EditorFilter with duplicate sibling filters removed.
 */
export function removeDuplicateSiblings(filter: EditorFilter): EditorFilter {
    filter.nested = filter.nested.filter((nestedFilter, index, nestedArray) => {
        const isDuplicate =
            nestedArray.findIndex(
                (sibling) => sibling.id === nestedFilter.id,
            ) !== index;
        if (isDuplicate) {
            return false; // Exclude the filter if it shares the same ID as a sibling
        } else {
            removeDuplicateSiblings(nestedFilter); // Recursively remove from nested filters
            return true; // Include the filter in the nested filters
        }
    });

    return filter;
}
